import { Pais } from './pais';

export class Provincia {
	id: number;
	codigoINDEC: string;
	pais: Pais;
	descripcion: string;
	codigo: string;
	public descripcionPaisProvincia: string;
	activo: boolean;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.pais = new Pais(data.pais);
			this.descripcion = data.descripcion;
			this.codigo = data.codigo;
			this.descripcionPaisProvincia = data.pais.descripcion + ', ' + data.descripcion;
			this.activo = data.activo;
		}
	}
}
